/* global axios */
import ApiClient from '../ApiClient';

class ElectoralCampaignFieldAPI extends ApiClient {
  constructor() {
    super('electoral_campaign/field', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }

  summary() {
    return axios.get(`${this.url}/summary`);
  }

  byCity() {
    return axios.get(`${this.url}/by_city`);
  }

  hierarchy() {
    return axios.get(`${this.url}/hierarchy`);
  }

  countdown() {
    return axios.get(`${this.url}/countdown`);
  }
}

export default new ElectoralCampaignFieldAPI();
